import apiRequest from "../utils/ApiRequest/apiRequest";

const UpdateAdViewCountApiRequest = async (
  payload: UpdateAdViewCountApiRequestPayloadT
) => {
  const response = await apiRequest(
    "background",
    "UpdateAdViewCount",
    payload,
    "POST"
  );

  return response;
};

const UpdateAdClickCountApiRequest = async (
  payload: UpdateAdClickCountApiRequestPayloadT
) => {
  const response = await apiRequest(
    "background",
    "UpdateAdClickCount",
    payload,
    "POST"
  );
  return response;
};

export type UpdateAdViewCountApiRequestPayloadT = {
  isDesktop: boolean;
  adId: number;
  location: "Home" | "Download";
};

export type UpdateAdClickCountApiRequestPayloadT = {
  isDesktop: boolean;
  adId: number;
  logId: number;
};

export { UpdateAdViewCountApiRequest, UpdateAdClickCountApiRequest };
